import { createStore, applyMiddleware } from 'redux'
import reducers from 'state/reducers'
import sagas from 'state/sagas'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'


const sagaMiddleware = createSagaMiddleware()
const logger = createLogger()
const store = createStore(
  reducers,
  applyMiddleware(
    logger,
    sagaMiddleware
  )
)
sagaMiddleware.run(sagas)

export default store



// WEBPACK FOOTER //
// ./src/state/store.js